'use client';

import { Suspense } from 'react';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import '@/styles/headerfooter.css';
import '@/styles/responsive/legal.css';
import ZapChat from '@/components/ZapChat';

export default function RefundPage() {
  return (
    <>
      <ZapChat />
      <main id="main-content" className="min-h-screen">
        <Suspense
          fallback={
            <div className="fixed top-0 right-0 left-0 z-50 h-[72px] border-black/5 border-b bg-white shadow-sm" />
          }
        >
          <Header />
        </Suspense>

        {/* Refund Policy Section */}
        <section className="refund-page">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Refund Policy</h2>
            </div>

            <div className="refund-content">
              <section className="refund-section">
                <h3 className="text-gray-950">1. Project Deposits and Payments</h3>
                <p>
                  All projects are confirmed once payment is received through Stripe or invoice.
                </p>
                <p>Custom development work payments are non-refundable once work has begun.</p>
                <p>
                  If a client cancels before any work has started, a full refund will be issued
                  (minus any Stripe transaction fees).
                </p>
              </section>

              <section className="refund-section">
                <h3 className="text-gray-950">2. Retainer Services</h3>
                <p>
                  Monthly retainers are billed automatically through Stripe under a 12-month rolling
                  contract.
                </p>
                <p>Retainers can be cancelled at any time with 30 days&apos; written notice.</p>
                <p>
                  Payments already made cover the current month&apos;s support and are
                  non-refundable.
                </p>
                <p>
                  If a retainer is cancelled partway through a billing cycle, service will continue
                  until the end of that paid period.
                </p>
              </section>

              <section className="refund-section">
                <h3 className="text-gray-950">3. Delivery Issues or Dissatisfaction</h3>
                <p>
                  If you believe work hasn&apos;t been delivered as agreed, please contact us within
                  7 days of delivery.
                </p>
                <p>We&apos;ll review the issue and, if appropriate, offer either:</p>
                <ul className="refund-list">
                  <li>a reasonable fix or revision at no cost, or</li>
                  <li>
                    a partial refund based on the portion of work not completed to the agreed
                    standard.
                  </li>
                </ul>
              </section>

              <section className="refund-section">
                <h3 className="text-gray-950">4. Technical Failures</h3>
                <p>
                  In rare cases where ZappingAI cannot deliver a project due to unforeseen technical
                  limitations or third-party platform issues, we will either:
                </p>
                <ul className="refund-list">
                  <li>provide a full refund for the undelivered work, or</li>
                  <li>apply a credit toward future services — whichever the client prefers.</li>
                </ul>
              </section>

              <section className="refund-section">
                <h3 className="text-gray-950">5. Disputes</h3>
                <p>Refunds are processed through the same payment method used (via Stripe).</p>
                <p>
                  Clients agree to contact ZappingAI first to resolve any concerns before opening a
                  dispute.
                </p>
              </section>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
